import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService, USER_KEY } from '../service/storage.service';
import { User, UserType } from '../models/user';
import { AuthService } from '../service/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
 
  const token = authService.getAccessToken();
 
  if (token) {
    return true;
  }
 
  router.navigateByUrl('/login');
  return false;
};
 
export const authGuardSI: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  const authService = inject(AuthService);
 
  const user: User = storageService.getObject(USER_KEY);
  const token = authService.getAccessToken();
 
  if (user?.id && token) {
    return true;
  }
 
  router.navigateByUrl('/login');
  return false;
};
 
export const authGuardLS: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  const authService = inject(AuthService);
 
  const user: User = storageService.getObject(USER_KEY);
  const token = authService.getAccessToken();
 
  if (user?.user_type === UserType.LARGE_SCALE && token) {
    return true;
  }
 
  router.navigateByUrl('/login');
  return false;
};
 
export const authGuardWD: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  const authService = inject(AuthService);
 
  const user: User = storageService.getObject(USER_KEY);
  const token = authService.getAccessToken();
 
  if (user?.user_type === UserType.WEB_DYN && token) {
    return true;
  }
 
  router.navigateByUrl('/login');
  return false;
};
 